import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ServiceItem } from '.';
import { environment } from '../../environments/environment';
import { PostingType } from '../lookups';
import { Guid, IGenericResponse, IStatusMessage } from '../shared';
import { LoadingService } from '../shared/loading';
import { LoggingService } from '../shared/services/logging/logging.service';
import * as fromRoot from '../store';

@Injectable({
    providedIn: 'root'
})
export class ServiceItemService extends LoadingService {
    private uri = `${environment.apiLocation}/ServiceItemSetting`;
    private serviceItemPostingTypeUri = `${environment.apiLocation}/ServiceItemPostingType`;

    constructor(
        private http: HttpClient,
        protected log: LoggingService,
        protected rootStore: Store<fromRoot.CoreState>
    ) {
        super(rootStore);
    }
    public get(): Observable<ServiceItem[]> {
        super.Load();
        return this.http
            .get<ServiceItem[]>(this.uri)
            .pipe(tap(() => super.Stop()));
    }
    public post(SIListIds: string[]): Observable<ServiceItem[]> {
        super.Load();
        return this.http
            .post<ServiceItem[]>(this.uri, { SIListId: SIListIds })
            .pipe(tap(() => super.Stop()));
    }
    public put(items): Observable<IGenericResponse<ServiceItem>> {
        // return getTestServiceError<ServiceItem>(17, items as ServiceItem[], 'SIListID');

        return this.http.put<IGenericResponse<ServiceItem>>(this.uri, {
            ServiceItemSettingList: items
        });
    }
    public getServiceItemPostingTypes(): Observable<PostingType[]> {
        return this.http.get<any[]>(this.serviceItemPostingTypeUri).pipe(
            map(items =>
                items.map(x => ({
                    id: Guid.newGuid(),
                    PostingType: x.SIpostingtype as string,
                    Description: x.SIpostingtypedesc as string,
                    ListID: x.SIListID as string,
                    Status: x.Status as IStatusMessage,
                    Row_Version: null
                }))
            )
        );
    }
}
